// import { data } from "isotope-layout";
import PropTypes from "prop-types";
import React from 'react';
// import {Link} from "react-router-dom";
import FileName from '../../data/pic/filename.json';



const WorkDetailsContainer = () => {
    // const cate = data.categories.map((value, i) => {
    //     return(
    //         <span className="d-inline" key={i}>{value}{i !== data.categories.length - 1 && " , "}</span>
    //     )
    // })
    return (
        <div className="section section-padding">
            <div className="container">
                <div className="row pt--100 pb--80">

                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="work-left work-details" data-aos="fade-up">
                            <div className="portfolio-main-info">
                                <h2 className="title">Wonderful Moments </h2>
                                <div className="work-details-list mt-12">

                                    <div className="details-list">
                                        <label>Years</label>
                                        <span>2024</span>
                                    </div>
                                    <div className="details-list">
                                        <label>Date</label>
                                        <span>23rd-26th, August</span>
                                    </div>

                                    <div className="details-list">
                                        <label>Location</label>
                                        <span>Xining, China</span>
                                    </div>


                                    {/* <div className="details-list">
                                        <label>Awards</label>
                                        <span>{data.awards}</span>
                                    </div> */}

                                </div>
                                {/* <div className="work-share pt--70 pt_md--40 pt_sm--40">
                                    <h6 className="heading heading-h6">SHARE</h6>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-6 offset-lg-1 col-12">
                        <div className="work-left work-details mt-6">
                            <div className="work-main-info">
                                <div className="work-content">
                                    <h4 className="title" data-aos="fade-up">The Fifteenth International Conference on Swarm Intelligence (ICSI&apos;2024)</h4>

                                    <div className="desc mt-8">
                                        <p>
                                        Shenzhen, China - The Fifteenth International Conference on Swarm Intelligence (ICSI&apos;2024) was successfully held in Shenzhen on August 23rd-26th, 2024. The conference brought together leading researchers, practitioners, and academics from around the world to explore the latest trends and advancements in swarm intelligence.
                                        </p>

                                        <p>
                                            The theme of ICSI&apos;2024 is &quot;Serving Life with Swarm Intelligence&quot;. The ICSI&apos;2024 provided an excellent opportunity and/or an academic forum for academics and practitioners to present and discuss the latest scientific results and methods, innovative ideas, and advantages in theories, technologies, and applications in swarm intelligence. The technical program covered a number of aspects of swarm intelligence and its related areas.

                                        </p>

                                        <p>
                                        The three-day conference featured keynote speeches, technical sessions, oral presentations, and workshops, covering a wide range of topics related to swarm intelligence, including swarm robotics, swarm optimization, swarm intelligence in social systems, and more. The conference also provided an excellent opportunity for researchers and practitioners to exchange ideas, network, and collaborate on new research projects.
                                        </p>





                                        {/* {data.body.map((value, i) => {
                                            return(
                                                <div key={i} className="content mb-5" data-aos="fade-up" dangerouslySetInnerHTML={{__html: value}} />
                                            )
                                        })} */}
                                        {/* DONE: fix the linkage problem  */}
                                        {/* <div className="work-btn" data-aos="fade-up">
                                            <a className="btn btn-primary btn-hover-secondary" href="www.baidu.com">Baidu</a>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Opening Ceremony</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The conference was inaugurated on August 24th at 8:30 AM, presided over by Professors Shi Yuhui. Following the commencement, conference chair Professor Tan Ying delivered the opening speech. Professor Ying Tan reported on the current status of this year&apos;s conference and extended a warm welcome to everyone. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="custom-column-thumbnail mt-lg-14 mt-1" data-aos="fade-up">
                            <img className="w-50" src='./images/gallery/open1.jpg' alt="Agency" />
                            <img className="w-50" src='./images/gallery/open3.jpg' alt="Agency" />
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-lg-12">
                        <div className="custom-column-thumbnail mt-lg-14 mt-1" data-aos="fade-up">
                            <img className="w-50" src='./images/gallery/open3.jpg' alt="Agency" />
                            <img className="w-50" src='./images/gallery/open4.jpg' alt="Agency" />
                        </div>
                    </div>
                </div> */}

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech I</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                            Dr. Guoyin Wang, President of Chongqing Normal University, presented a comprehensive exploration of swarm intelligence, extending beyond traditional bio-inspired models to include human-machine hybrid swarm intelligence. He detailed a three-layer hierarchical framework for understanding swarm intelligence, emphasizing the limitations of bio-inspired models in dynamic cognitive tasks and the potential of integrating human intelligence. Dr. Wang also highlighted the applications of swarm intelligence in optimization, big data analysis, and unmanned systems, and outlined future research directions and key issues in the field.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/open10.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/open4.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    <br></br>
                </div>


                {/* ---------------------------invited best student paper presentation */}

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech II</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>
                                Dr. Hua Xu, a tenured associate professor at Tsinghua University, discussed the challenges and advancements in solving ultra-large-scale integer linear programming (ILP) and mixed integer linear programming (MILP) problems. He introduced machine learning-guided evolutionary optimization as a promising approach to address high-dimensional optimization issues, such as those encountered in integrated circuit design and internet operation scheduling. Dr. Xu highlighted significant progress in this area, including the development of the θ-dominance evolutionary algorithm, and its successful applications in various high-impact fields like power optimization and quantum control.

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/open5.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/open6.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    <br></br>
                   
                </div>
                {/* -------------------------------------------------------------- */}
                {/* -----------------------------------inv talk-------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech III</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>Prof. Jing Liang, Vice President of Henan University of Technology, provided insights into the fundamental theories and practical applications of evolutionary computation. She focused on evolutionary multimodal multi-objective optimization and constrained optimization methods, showcasing their effectiveness in solving complex problems in image processing and biomedical research. Prof. Liang, an esteemed researcher with numerous accolades, also emphasized the wide applicability of these algorithms across various domains, supported by her extensive research and high citation impact in the field.</p>


                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img  src="./images/gallery/open7.jpg" alt="Agency"  />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/open8.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    {/* <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div> */}
                </div>
                {/* -------------------------------------------------------------- */}
                {/* parellel sessions */}
                {/* -------------------------------------------------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Parallel Sessions</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The conference continued on July 15th and the morning of July 16th with paper presentations by participating authors spread across five conference rooms. Attendees chose sessions based on their interests, leading to engaging conversations and fruitful interactions with the presenters.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    {/* <div className="col-lg-12 my-6">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/plenary talk 1.jpg" alt="Agency" />
                            </div>
                        </div> */}
                    {/* small one */}

                    <div className="row">

                        {FileName.map((data, i) => {
                            return (
                                <div className="col-lg-4 col-md-4 col-12" key={i}>
                                    <div className="thumbnail" data-aos="fade-up">
                                        <img className="w-100" src={"./images/gallery/" + data.file} alt={data.file} />
                                    </div>
                                </div>
                            )
                        })}


                        {/* <div className="col-lg-4 col-md-4 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src={"./images/gallery/"+ data.file} alt="Agency" />
                            </div>
                        </div>  */}



                        {/* <div className="col-lg-4 col-md-4 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div> */}


                    </div>
                </div>
                {/* -------------------------------------------------------------- */}
                {/* award ceremony */}
                {/* -------------------------------------------------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Award Ceremony
                            </h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>On the evening of August 24th, a welcome dinner was held at 6 PM, marking a festive occasion where the winners of the Best Paper and Best student Paper were announced and awarded. Prof. Ying  took a group photo with them. </p>
                                <p>
                                Additionally, Prof. Shi Yuhui announced the plans for ICSI&apos;2025, which will take place in Yokohama, Japan. We welcome everyone to attend the next conference.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    {/* <div className="col-lg-12 my-6">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/plenary talk 1.jpg" alt="Agency" />
                                        </div>
                                    </div> */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/o1.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/o2.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    <br></br>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/o3.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>


                </div>


                {/* -------------------------------------------------------------- */}


            </div>
        </div>
    )
}

WorkDetailsContainer.propTypes = {
    data: PropTypes.object
};

export default WorkDetailsContainer;
